import { isNamedPlaceHolder } from './match-point-regex.js';
import { NamedPlaceHolder } from './named-placeholder.js';

/**
 * UI Callback 管理器基类
 *
 * @typeparam C - 原始配置项接口
 * @public
 */
class CallbackConfigMap {
    constructor() {
        this.callbacks = new Map();
        this.namedPlaceHolder = new NamedPlaceHolder();
    }
    /**
     * 获取callback config, 包括named placeholder match的callback
     * @param key - callback name
     * @returns
     */
    getAll(key) {
        var _a, _b;
        const callbackConfig = new Map();
        // named placeholder 查询
        const matchPoint = this.namedPlaceHolder.getMemorizedMatchPoint(key);
        (_a = this.callbacks.get(matchPoint !== null && matchPoint !== void 0 ? matchPoint : '')) === null || _a === void 0 ? void 0 : _a.forEach((runner, name) => callbackConfig.set(name, runner));
        // 普通字符串key查询
        (_b = this.callbacks.get(key)) === null || _b === void 0 ? void 0 : _b.forEach((runner, name) => callbackConfig.set(name, runner));
        // 注意这里有一个隐含的覆盖策略
        // 通过named placeholder查到
        // callbacks: {
        //   'click': runner1,
        //   'onmouseover': runner2
        // }
        //
        // 通过普通字符串key查询
        // callbacks: {
        //   'click': runner3
        // }
        //
        // 因为普通字符串有更高的优先级, 则最终结果为:
        // callbacks: {
        //   'click': runner3,
        //   'onmouseover': runner2
        // }
        return callbackConfig;
    }
    /**
     * 获取callback config, 不包括named placeholder match的callback
     * @param key - callback name
     * @returns
     */
    get(key) {
        return this.callbacks.get(key);
    }
    /**
     * 设置callback config
     * @param key - callback key
     * @param callbackConfig -
     */
    set(key, callbackConfig) {
        this.callbacks.set(key, callbackConfig);
        // 记住named parameter格式的字符串
        if (isNamedPlaceHolder(key)) {
            this.namedPlaceHolder.addMatchPoint(key);
        }
    }
    /**
     * 根据key获取match point
     * @param key - callback key
     * @returns
     */
    getMatchPoint(key) {
        return this.namedPlaceHolder.getMatchPoint(key);
    }
}

export { CallbackConfigMap };
//# sourceMappingURL=callback-config-map.js.map
